/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              NCSK.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var NCSK = NCSK || {};

// Document ready
$(function () {
    // Only include Novicell functions that you use!
    novicell.map.init();
    novicell.cookieInfo.init();
    novicell.responsiveLazyloadImage.onLoad();
    novicell.embed.onLoad();
    NCSK.languagePicker.init();
    // Call new functions here like this:
    NCSK.slider.initImageSlider('.owl-carousel');
    NCSK.navigation.init();
    NCSK.gridBackground.init();


    svg4everybody(); // Fix SVG spritemap in IE/Edge

}); // Document ready end


/*
 *  Use the following if needed
 */

// Window load
// $(window).load(function(e){
//     // call functions here
// }); // Window load

// Window resize (debounced)
$(window).smartresize(function (e) {
    novicell.responsiveLazyloadImage.onResize();
    novicell.embed.onResize();
}); // Window resize

// Window scroll (debounced)
$(window).smartscroll(function (e) {
    novicell.embed.onScroll();
    novicell.responsiveLazyloadImage.onLoad();

}); // Window scroll

// // Window mousemove (debounced)
// $(window).smartmousemove(function(e){
//     // do stuff as soon as the user stops moving his mouse for longer than 100ms
// }); // Window mousemove